import { Component, HostListener, Input, OnInit } from '@angular/core'
import { selectTaskById, TaskResponse } from '@tokeet-frontend/tasks'
import { UpdateTask } from '@tokeet-frontend/tasks'
import { Store } from '@ngrx/store'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-task-star-btn',
  templateUrl: './task-star-btn.component.html',
  styleUrls: ['./task-star-btn.component.scss'],
})
export class TaskStarBtnComponent extends Destroyable implements OnInit {
  @Input() task: TaskResponse

  isStarred = false

  @HostListener('click') onToggle() {
    this.store.dispatch(
      UpdateTask({
        id: this.task.pkey,
        form: { marked: this.isStarred ? 0 : 1 },
      })
    )
  }

  constructor(private store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store
      .select(selectTaskById(this.task.pkey))
      .pipe(untilDestroy(this))
      .subscribe((task) => {
        this.isStarred = !!task.marked
      })
  }
}
